// Фактически достает айди компании из урл-параметров
export function getUniqKeyForCacheFromPayload(payload) {
	return payload?.urlParams?.companyId
}

export function createModuleCacheKey(moduleName, uniqKey) {
	return `${moduleName}--${uniqKey}`
}

export function transformVersions(versionsEntries) {
	return (versionsEntries || []).reduce((acc, [moduleName, versionHash, , uniqKey]) => {
		acc[createModuleCacheKey(moduleName, uniqKey)] = versionHash
		return acc
	}, {})
}

export async function getCacheVersion(uniqKey, cacheKey, cacheService) {
	const currentVersions = await cacheService.getCurrentVersions(uniqKey)

	return currentVersions?.[cacheKey]
}

export function defaultGetEntityIdFromUrlParams(payload) {
	const urlParams = payload?.urlParams

	if (!urlParams) {
		throw new Error('urlParams in request payload is not defined, payload: ' + JSON.stringify(payload))
	}

	const filteredKey = Object.keys(urlParams).filter(key => key !== 'companyId')

	if (filteredKey.length > 1) {
		throw new Error('urlParams in request payload contains more than one key, payload: ' + JSON.stringify(payload))
	}

	if (!filteredKey[0]) {
		throw new Error('urlParams in request payload contains no keys, payload: ' + JSON.stringify(payload))
	}

	return urlParams[filteredKey[0]]
}

export function defaultGetSingleCachedEntity(dataArrayFromCache, id) {
	return (dataArrayFromCache?.find && dataArrayFromCache?.find(item => item.id === id))|| null
}

export async function delayPromiseResult(promise) {
	let promiseResult = null;
	let error = null;

	try {
		promiseResult = await promise;
	} catch (e) {
		error = e;
	}

	return function() {
		if (error) {
			return Promise.reject(error);
		}

		return Promise.resolve(promiseResult);
	}
}
